import {addBetSettingsSection, showBetSettingsSection} from "./betSettingsSection";
import {addAutoBetSelector, hideAutoBetSelector, showAutoBetSelector, stopAutoSpin} from "./autoSpin";
import {
    addBalanceInfoText,
    addBetAmountInfoText,
    addFreeSinsLeftInfoText, addFreeSpinLeftInfoText,
    addWinAmountInfoText,
    hideFreeSinsLeftInfoText
} from "./amountText";
import {brightnessBtnFilter, darkBtnFilter} from "./filters";
import {handleSpinButton} from "../slotBoard/spin";
import {showInfoSection} from "../infoSection";
import {getAmountWithCurrency, universalClick} from "../utilites";
import {pixiComponents} from "../index";
import {cpConfigs} from "./configs";
import * as PIXI from 'pixi.js';
import {gsap} from "gsap";
import {coinSound, isSoundOff, soundToggle} from "../soundService";
import {addShortNotification} from "../notifications/shortNotifications";
import {showHistorySection} from "../historySection";
import {freeSpinStore, spinStore, store} from "../store";
import {CANVAS} from "../constants/configs";
import {OtherGamesSection} from "./otherGamesSection";
import {freeBetGame} from "../freeBetGame";

export const addControlPanel = () => {
    const controlPanelContainer = new PIXI.Container();
    pixiComponents.app.stage.addChild(controlPanelContainer);

    pixiComponents.controlPanelContainer = controlPanelContainer;
    controlPanelContainer.y = cpConfigs.y;

    addControlPanelBackground();

    const autoBetSelector = addAutoBetSelector();
    const betSettingsSection = addBetSettingsSection();

    const cpItems = {
        historyBtn: addHistoryBtn(),
        soundSwitcher: addSoundSwitcherBtn(),
        infoBtn: addInfoBtn(),
        amountBtn: addAmountBtn(),
        autoSpinBtn: addAutoSpinBtn(),
        spinBtn: addSpinBtn(),
        stopSpinBtn: addStopSpinBtn(),
        balanceAmountText: addBalanceInfoText(),
        betAmountText: addBetAmountInfoText(),
        stopAutoSpinBtn: addStopAutoSpinBtn(),
        winAmountText: addWinAmountInfoText(),
        freeSinsLeftText: addFreeSinsLeftInfoText(),
        freeSpinLeftText: addFreeSpinLeftInfoText(),
        autoBetSelector,
        betSettingsSection,
        otherGamesSection: new OtherGamesSection(pixiComponents.app.stage),
    };

    controlPanelContainer.addChild(autoBetSelector);
    controlPanelContainer.addChild(betSettingsSection);

    pixiComponents.cpItems = cpItems;

    hideWinAmountInfoText();
    hideFreeSinsLeftInfoText();
    pixiComponents.cpItems.freeSpinLeftText.container.visible = false;
}

export const setVisibleForSomeControlPanelItems = (bool) => {
    pixiComponents.cpItems.spinBtn.visible = bool;
    pixiComponents.cpItems.stopSpinBtn.visible = bool;
    pixiComponents.cpItems.stopAutoSpinBtn.visible = bool;
    pixiComponents.cpItems.autoSpinBtn.visible = bool;
    pixiComponents.cpItems.amountBtn.visible = bool;
    hideAutoBetSelector();
}

export const updateSpinBtnState = ({isSpinning, isAutoSpinning}) => {
    if (freeSpinStore.freeSpin || freeSpinStore.isBonusGameStarted) {
        return;
    }
    if (isAutoSpinning) {
        pixiComponents.cpItems.amountBtn.alpha = 0.65;
        pixiComponents.cpItems.amountBtn.eventMode = "none";
        pixiComponents.cpItems.autoSpinBtn.alpha = 0.65;
        pixiComponents.cpItems.autoSpinBtn.eventMode = "none";

        pixiComponents.cpItems.spinBtn.visible = false;
        pixiComponents.cpItems.stopSpinBtn.visible = false;
        pixiComponents.cpItems.stopAutoSpinBtn.visible = true;
        return;
    } else if (isSpinning) {
        pixiComponents.cpItems.amountBtn.alpha = 0.65;
        pixiComponents.cpItems.amountBtn.eventMode = "none";
        pixiComponents.cpItems.autoSpinBtn.alpha = 0.65;
        pixiComponents.cpItems.autoSpinBtn.eventMode = "none";

        pixiComponents.cpItems.spinBtn.visible = false;
        pixiComponents.cpItems.stopSpinBtn.visible = true;
        pixiComponents.cpItems.stopAutoSpinBtn.visible = false;
        return;
    } else if (freeBetGame.isFreeBetGameStarted) {
        pixiComponents.cpItems.amountBtn.alpha = 0.65;
        pixiComponents.cpItems.amountBtn.eventMode = "none";
        pixiComponents.cpItems.autoSpinBtn.alpha = 1;
        pixiComponents.cpItems.autoSpinBtn.eventMode = "static";
        pixiComponents.cpItems.spinBtn.visible = true;
        pixiComponents.cpItems.stopSpinBtn.visible = false;
        pixiComponents.cpItems.stopAutoSpinBtn.visible = false;
        return;
    }
    pixiComponents.cpItems.amountBtn.alpha = 1;
    pixiComponents.cpItems.amountBtn.eventMode = "static";
    pixiComponents.cpItems.autoSpinBtn.alpha = 1;
    pixiComponents.cpItems.autoSpinBtn.eventMode = "static";
    pixiComponents.cpItems.spinBtn.visible = true;
    pixiComponents.cpItems.stopSpinBtn.visible = false;
    pixiComponents.cpItems.stopAutoSpinBtn.visible = false;
}

const addControlPanelBackground = () => {
    const rect = new PIXI.Graphics();
    pixiComponents.controlPanelContainer.addChild(rect);
    rect.beginFill('rgba(0,0,0,0.0)');
    rect.drawRect(0, -5, cpConfigs.width, cpConfigs.height + 5);
    rect.endFill();
}

const addHistoryBtn = () => {
    const historyButton = createButton(cpConfigs.historyBtn, store.isDemo());
    pixiComponents.controlPanelContainer.addChild(historyButton);
    universalClick(historyButton, () => {
        showHistorySection();
    })

    return historyButton;
}

const addSoundSwitcherBtn = () => {
    const soundSwitcherBtn = createButton(cpConfigs.soundSwitcherBtn);
    pixiComponents.controlPanelContainer.addChild(soundSwitcherBtn);
    universalClick(soundSwitcherBtn, () => {
        store.soundToggle();
        soundSwitcherBtn.texture = PIXI.Texture.from(store.isSoundOff ? "muteSound.png" : "sound.png");
        // addShortNotification("error", "Bet Not Accepted");
    })

    return soundSwitcherBtn;
}

const addInfoBtn = () => {
    const infoBtn = createButton(cpConfigs.infoBtn);
    pixiComponents.controlPanelContainer.addChild(infoBtn);
    universalClick(infoBtn, showInfoSection);

    return infoBtn;
}

const addAmountBtn = () => {
    const amountBtn = createButton(cpConfigs.amountBtn);
    pixiComponents.controlPanelContainer.addChild(amountBtn);
    universalClick(amountBtn, () => {
        coinSound.play();
        showBetSettingsSection();
    });
    return amountBtn;
}

const addAutoSpinBtn = () => {
    const autoSpinBtn = createButton(cpConfigs.autoSpinBtn);
    pixiComponents.controlPanelContainer.addChild(autoSpinBtn);
    universalClick(autoSpinBtn, showAutoBetSelector);
    addPixiHover(autoSpinBtn, {rotation: 0.2}, 0.1);
    return autoSpinBtn;
}

const addSpinBtn = () => {
    const spinBtn = createButton(cpConfigs.spinBtn);
    pixiComponents.controlPanelContainer.addChild(spinBtn);
    universalClick(spinBtn, handleSpinButton);
    // addPixiHover(spinBtn, {rotation: 0.8}, 0.25);
    return spinBtn;
}

const addStopAutoSpinBtn = () => {
    const stopAutoSpinBtnContainer = new PIXI.Container();
    stopAutoSpinBtnContainer.visible = false;
    stopAutoSpinBtnContainer.x = cpConfigs.stopAutoSpinContainer.x;
    stopAutoSpinBtnContainer.y = cpConfigs.stopAutoSpinContainer.y;
    pixiComponents.controlPanelContainer.addChild(stopAutoSpinBtnContainer);

    const stopAutoSpinBtn = createButton(cpConfigs.stopAutoSpinContainer.btn);
    const countdownText = new PIXI.Text(0, {
        fontFamily: 'BebasNeue',
        fontSize: cpConfigs.stopAutoSpinContainer.btn.fontSize,
        fill: "rgb(236,236,236)",
    });
    countdownText.anchor.set(0.5, 0.45);

    stopAutoSpinBtnContainer.addChild(stopAutoSpinBtn);
    stopAutoSpinBtnContainer.addChild(countdownText);
    stopAutoSpinBtnContainer.countdownText = countdownText;
    universalClick(stopAutoSpinBtn, stopAutoSpin);

    return stopAutoSpinBtnContainer;
}

const addStopSpinBtn = () => {
    const stopSpinBtn = createButton(cpConfigs.stopSpinBtn);
    pixiComponents.controlPanelContainer.addChild(stopSpinBtn);
    universalClick(stopSpinBtn, handleSpinButton)
    stopSpinBtn.visible = false;

    return stopSpinBtn;
}

export const updateBalanceInfoText = (newBalance) => {
    const {amount, title} = pixiComponents.cpItems.balanceAmountText;
    amount.text = getAmountWithCurrency(newBalance.toFixed(2), store.currency);
    amount.x = title.x + title.width + 10;
    amount.y = title.y;
}

export const updateBetAmountInfoText = (newSpinAmount) => {
    const {amount, title} = pixiComponents.cpItems.betAmountText;
    amount.text = getAmountWithCurrency(newSpinAmount.toFixed(2), store.currency);
    amount.x = title.x + title.width + 10;
    amount.y = title.y;
}


export const setWinAmountInfoText = (winAmount) => {
    winAmount = (winAmount * 1).toFixed(2);
    const container = pixiComponents.cpItems.winAmountText.container;
    const amountText = pixiComponents.cpItems.winAmountText.amount;
    amountText.text = getAmountWithCurrency(winAmount, store.currency);
    amountText.currentAmount = winAmount;

    container.visible = true
    container.pivot.set(container.width / 2, container.height / 2);
    container.x = pixiComponents.app.screen.width / 2;
    freeBetGame.setFreeSpinLeftTextVisibility(false);
}

export const setWinAmountInfoTextInitial = () => {
    if (freeBetGame.isFreeBetGameStarted) {
        freeBetGame.setFreeSpinLeftTextVisibility(true);
    }
    pixiComponents.cpItems.winAmountText.amount.currentAmount = 0;
    pixiComponents.cpItems.winAmountText.container.visible = false;
}

export const growWinAmountTo = (newWinAmount) => {
    const {currentAmount} = pixiComponents.cpItems.winAmountText.amount;
    const data = {amount: currentAmount};
    gsap.to(data, {
        amount: newWinAmount,
        duration: 0.3,
        onUpdate: () => {
            if (currentAmount) {
                setWinAmountInfoText(data.amount.toFixed(2));
            } else {
                setWinAmountInfoText(newWinAmount.toFixed(2));
            }
        },
    })
}

export const hideWinAmountInfoText = () => {
    pixiComponents.cpItems.winAmountText.container.visible = false;
}

export const addPixiHover = (pixiObject, hoverChangeObj, duration) => {
    let initialState = {};
    let gsapAnimation;
    Object.entries(hoverChangeObj).forEach(([key, value]) => {
        initialState[key] = pixiObject[key]
    });

    pixiObject.on('mouseover', () => {
        gsapAnimation?.kill();
        gsapAnimation = gsap.to(pixiObject, {
            ...hoverChangeObj,
            duration,
        });
    });

    pixiObject.on('mouseout', () => {
        gsapAnimation?.kill();
        gsapAnimation = gsap.to(pixiObject, {
            ...initialState,
            duration,
        });
    });
}

export const addPixiEventAnimation = ({event, pixiObject, changeObj}) => {
    let gsapAnimation;

    pixiObject.on(event, () => {
        gsapAnimation?.kill();
        gsapAnimation = gsap.to(pixiObject, {
            ...changeObj,
        });
    });

}

export const createButton = ({textureName, x, y, width, height}, disabled = false) => {
    const buttonSprite = new PIXI.Sprite(PIXI.Texture.from(textureName));
    buttonSprite.anchor.set(0.5, 0.5);
    buttonSprite.x = x;
    buttonSprite.y = y;
    buttonSprite.width = width;
    buttonSprite.height = height;

    if (disabled) {
        buttonSprite.filters = [darkBtnFilter];
        buttonSprite.alpha = 0.6;
        return buttonSprite;
    }

    const setBtnSpriteDarkness = () => buttonSprite.filters = [darkBtnFilter];
    const setBtnSpriteBrightness = () => {
    };//buttonSprite.filters = [brightnessBtnFilter];
    const setBtnSpriteNonFilter = () => buttonSprite.filters = [];

    buttonSprite.eventMode = 'static';
    buttonSprite.cursor = 'pointer';

    buttonSprite.on('mousedown', setBtnSpriteDarkness);
    buttonSprite.on('mouseup', setBtnSpriteBrightness);
    buttonSprite.on('mouseover', setBtnSpriteBrightness);
    buttonSprite.on('mouseout', setBtnSpriteNonFilter);
    buttonSprite.on('touchstart', setBtnSpriteDarkness);
    buttonSprite.on('touchend', setBtnSpriteNonFilter);
    buttonSprite.on('touchmove', setBtnSpriteNonFilter);

    addPixiHover(buttonSprite, {
        width: width * 1.02,
        height: height * 1.02,
    }, 0.15);

    return buttonSprite;
}
